exports.list = {
    path: '/calendar_inspeksi',
    name: 'calendar_inspeksi_list', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/calendar_inspeksi/List.vue"),
}
exports.show = {
    path: '/calendar_inspeksi/show/:id',
    name: 'calendar_inspeksi_show', 
        meta: {
            authRequired: true,
        },
    component: () => import("@/views/main/calendar_inspeksi/Show.vue"),
}